import React, { ReactNode } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'success' | 'danger';
type IconPosition = 'left' | 'right';

interface BaseButtonProps {
    title: ReactNode;
    onClick?: any;
    loading?: boolean;
    disabled?: boolean;
    className?: string;
    variant?: ButtonVariant;
    iconPosition?: IconPosition;
    icon?: ReactNode;         // Normal icon
    loadingIcon?: ReactNode;  // Icon shown when loading
    children?: React.ReactNode;
    id?: string;
    type?: 'button' | 'submit' | 'reset';
}

const BaseButton: React.FC<BaseButtonProps> = ({
    title,
    onClick,
    loading = false,
    disabled = false,
    className = '',
    variant = 'primary',
    iconPosition = 'left',
    icon,
    loadingIcon,
    id,
    type = 'button',
}) => {
    const variantClasses: Record<ButtonVariant, string> = {
        primary: 'btn btn-primary waves-effect waves-light mb-2 border-0',
        secondary: 'btn btn-secondary waves-effect waves-light mb-2 border-0',
        success: 'btn btn-success waves-effect waves-light mb-2 border-0',
        danger: 'btn btn-danger waves-effect waves-light mb-2 border-0'
    };


    const renderIcon = () => {
        const iconToRender = loading ? loadingIcon : icon;
        if (!iconToRender) return null;

        return (
            <span >
                {iconToRender}
            </span>
        );
    };

    const getIconSideClass = (): string => {
        if (icon && (loading || icon)) {
            return iconPosition === 'left' ? 'btn-icon-left' : 'btn-icon-right';
        }
        return '';
    };

    return (
        <button
            className={`${variantClasses[variant]} d-flex gap-2 ${getIconSideClass()} ${className}`}
            onClick={onClick}
            disabled={disabled || loading}
            type={type}
            id={id}
        >
            {iconPosition === 'left' && renderIcon()}
            <span className={iconPosition === 'left' ? 'ms-2' : 'me-2'}>{title}</span>
            {iconPosition === 'right' && renderIcon()}
        </button>
    );
};

export default BaseButton;
